import React, { useState, useEffect } from 'react';
import { X, Shield } from 'lucide-react';
import { Button } from '../../components/ui/button';

const MyBookieCookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('mybookie_cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setShowBanner(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('mybookie_cookie_consent', 'accepted');
    localStorage.setItem('mybookie_cookie_consent_date', new Date().toISOString());
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('mybookie_cookie_consent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom duration-300">
      <div className="max-w-2xl mx-auto bg-white border border-[#E6E8E6] shadow-xl rounded-sm p-6">
        <div className="flex items-start gap-4">
          <div className="p-2 bg-[#E2ECE7] rounded-sm flex-shrink-0">
            <Shield className="w-5 h-5 text-[#0A2B1D]" />
          </div>
          <div className="flex-1">
            <h3 className="font-medium text-[#111614] mb-1">Cookie Preferences</h3>
            <p className="text-sm text-[#5C6661] mb-4">
              We use cookies to improve your experience, analyze site traffic, and personalize content. 
              Your financial data is always encrypted and secure.
            </p>
            <div className="flex flex-wrap gap-3">
              <Button 
                onClick={handleAccept}
                className="bg-[#0A2B1D] hover:bg-[#254D3D] text-white rounded-sm"
              >
                Accept All
              </Button>
              <Button 
                variant="outline"
                onClick={handleDecline}
                className="border-[#E6E8E6] text-[#5C6661] hover:bg-[#F6F5F2] rounded-sm"
              >
                Decline
              </Button>
            </div>
          </div>
          <button 
            onClick={handleDecline}
            className="text-[#8A948F] hover:text-[#111614] transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default MyBookieCookieConsent;
